import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './Gauge.scss';

var Gauge = /*#__PURE__*/function (_Component) {
  _inherits(Gauge, _Component);

  var _super = _createSuper(Gauge);

  function Gauge(props) {
    var _this;

    _classCallCheck(this, Gauge);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.firstInterval = setInterval(function () {
        if (_this.state.gaugeVal < _this.props.value + 10) {
          _this.setState({
            gaugeVal: _this.state.gaugeVal + 1
          });
        } else {
          clearInterval(_this.firstInterval);
          _this.secondInterval = setInterval(function () {
            if (_this.state.gaugeVal > _this.props.value) {
              _this.setState({
                gaugeVal: _this.state.gaugeVal - 1
              });
            } else {
              clearInterval(_this.secondInterval);
            }
          }, 1);
        }
      }, 2);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearInterval(_this.firstInterval);
      clearInterval(_this.secondInterval);
    });

    _this.state = {
      gaugeVal: 0
    }; // must have access to these in componentWillUnmount

    _this.firstInterval = null;
    _this.secondInterval = null;
    return _this;
  }

  _createClass(Gauge, [{
    key: "render",
    value: function render() {
      var bgImage = require('./gauge.png');

      return /*#__PURE__*/React.createElement("div", {
        className: styles.gauge
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.circle,
        style: {
          backgroundImage: "url(".concat(bgImage, ")")
        }
      }, /*#__PURE__*/React.createElement("svg", {
        width: "185px",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 200 100"
      }, /*#__PURE__*/React.createElement("circle", {
        cx: "100",
        cy: "100",
        r: "80",
        fill: "transparent"
      }), /*#__PURE__*/React.createElement("line", {
        transform: "rotate(".concat(this.state.gaugeVal, ", 100, 100)"),
        x1: "40",
        y1: "100",
        x2: "100",
        y2: "100",
        strokeWidth: "3",
        stroke: "#333333"
      })), /*#__PURE__*/React.createElement("div", {
        className: styles.labels
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.leftLabel
      }, "Specific"), /*#__PURE__*/React.createElement("div", {
        className: styles.rightLabel
      }, "Broad"))));
    }
  }]);

  return Gauge;
}(Component);

export default Gauge;